import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../../../components/AdminLayout/AdminLayout';
import DashboardMainContainer from '../../../../components/common/Containers/DashboardMainContainer';
import {
  AdminPageTitle,
  AdminPanelTitle,
  AdminSupportingText,
  AdminMetadataText,
  AdminStatusBadge,
  AdminFormSecondaryAction,
  AdminRowAction,
  ADMIN_TOOLBAR_CLASS,
  ADMIN_TABLE_CLASS,
} from '../../shared/adminUx';

// Demo blog data - will be replaced with WordPress API integration
const DEMO_BLOGS = [
  {
    id: 101,
    title: 'Bathroom Renovation: Complete Step-by-Step Guide',
    excerpt: 'A detailed guide covering every aspect of bathroom renovation from planning to completion...',
    author: 'John Smith',
    category: 'Renovation',
    lastModified: '2024-01-14',
    status: 'draft',
  },
  {
    id: 102,
    title: 'HVAC Maintenance Checklist for Winter',
    excerpt: 'Essential HVAC maintenance tasks to prepare your heating system for the winter months...',
    author: 'Sarah Johnson',
    category: 'HVAC',
    lastModified: '2024-01-13',
    status: 'draft',
  },
  {
    id: 103,
    title: 'Sustainable Building Materials Guide',
    excerpt: 'Explore eco-friendly building materials and their benefits for modern construction...',
    author: 'Mike Williams',
    category: 'Construction',
    lastModified: '2024-01-11',
    status: 'draft',
  },
  {
    id: 104,
    title: 'Outdoor Decking: Material Comparison',
    excerpt: 'Compare different decking materials including wood, composite, and PVC options...',
    author: 'Emily Davis',
    category: 'Outdoor',
    lastModified: '2024-01-09',
    status: 'draft',
  },
];

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
};

const BlogDraft = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    // Simulate API call - will be replaced with WordPress API integration
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        setBlogs(DEMO_BLOGS);
      } catch (error) {
        console.error('Error fetching draft blogs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const handleEdit = (blogId) => {
    // TODO: Navigate to edit page (will be implemented with WordPress integration)
    console.log('Edit blog:', blogId);
  };

  const handlePublish = (blogId) => {
    // TODO: Publish blog (will be implemented with WordPress integration)
    console.log('Publish blog:', blogId);
  };

  if (loading) {
    return (
      <AdminLayout>
        <DashboardMainContainer className={ADMIN_TABLE_CLASS}>
          <div className="flex items-center justify-center h-96">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primaryblue"></div>
          </div>
        </DashboardMainContainer>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="tp-container-main">
        <div>
        <AdminPageTitle>Draft Articles</AdminPageTitle>
        <div className={ADMIN_TOOLBAR_CLASS}>
          <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
            <div className="flex-1" />
          </div>
        </div>

        {/* Blog List */}
        <DashboardMainContainer className={ADMIN_TABLE_CLASS}>
          {blogs.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16">
              <AdminSupportingText className="text-mediumgray text-center mb-4">No draft articles found</AdminSupportingText>
              <AdminSupportingText className="text-mediumgray text-center">
                Draft articles will appear here once they are created.
              </AdminSupportingText>
            </div>
          ) : (
            <div className="space-y-4">
              {blogs.map((blog) => (
                <div
                  key={blog.id}
                  className="border border-lightgray rounded-lg p-4 hover:border-primaryblue transition-colors"
                >
                  <div className="flex flex-col lg:flex-row gap-4">
                    {/* Content */}
                    <div className="flex-1 flex flex-col justify-between">
                      <div>
                        <div className="flex items-start justify-between gap-4 mb-2">
                          <AdminPanelTitle className="text-offblack line-clamp-2">{blog.title}</AdminPanelTitle>
                          <AdminStatusBadge status="Draft" label="Draft" className="whitespace-nowrap" />
                        </div>
                        <AdminSupportingText className="text-mediumgray mb-3 line-clamp-2 block">
                          {blog.excerpt}
                        </AdminSupportingText>
                        <div className="flex flex-wrap items-center gap-4">
                          <AdminMetadataText className="text-mediumgray">By {blog.author}</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">•</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">{blog.category}</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">•</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">Last modified: {formatDate(blog.lastModified)}</AdminMetadataText>
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="flex gap-2 mt-4">
                        <AdminRowAction onClick={() => handlePublish(blog.id)}>
                          Publish
                        </AdminRowAction>
                        <AdminFormSecondaryAction type="button" onClick={() => handleEdit(blog.id)}>
                          Edit
                        </AdminFormSecondaryAction>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DashboardMainContainer>
        </div>
      </div>
    </AdminLayout>
  );
};

export default BlogDraft;

